'use strict';
import { Debug } from '@svt/debug';
import fetch from '../../utils/fetchWithTimeout';

const debug = Debug('play:utils:SharedCountFetchAction:debug');
const error = Debug('play:SharedCountFetchAction:error');

const FETCH_TIME_OUT = 400; //ms
const SHARED_COUNT_URL = 'https://svt-sharedcount-production.herokuapp.com/shares';

export const SHARED_COUNT_UPDATE = 'SHARED_COUNT_UPDATE';
export const SHARED_COUNT_FETCH_ERROR = 'SHARED_COUNT_FETCH_ERROR';
export const SHARED_COUNT_UNREGISTER = 'SHARED_COUNT_UNREGISTER';

export function sharedCountResults(payload) {
    return {
        type: SHARED_COUNT_UPDATE,
        payload,
    };
}

export function sharedCountFetchError(payload) {
    return {
        type: SHARED_COUNT_FETCH_ERROR,
        payload,
    };
}

export function sharedCountUnregister(payload) {
    return {
        type: SHARED_COUNT_UNREGISTER,
        payload,
    };
}

export function sharedCountFetch(url) {
    return (dispatch) => {
        if (url) {
            debug('Executing SharedCountFetchAction for url "%s"', url);

            fetch(`${SHARED_COUNT_URL}?url=${url}`, FETCH_TIME_OUT)
                .then((resp) => resp.json())
                .then((json) => {
                    dispatch(sharedCountResults({ url: url, data: json }));
                })
                .catch((err) => {
                    error('Error fetching shared count for url "%s": %s', url, err);
                    dispatch(sharedCountFetchError(err.message));
                });
        }
    };
}
